exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2EPifIXtq4kg9ZNEwAb0Pf{position:absolute}.qFXpy6auqhuCRa2sQlMT4{width:216px;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}html[dir] .qFXpy6auqhuCRa2sQlMT4{padding:2px}", ""]);
// Exports
exports.locals = {
	"contextMenu": "_2EPifIXtq4kg9ZNEwAb0Pf",
	"charmContextMenuContainer": "qFXpy6auqhuCRa2sQlMT4"
};